import $ from "jquery";
import { gsap } from "gsap";
import imagesLoaded from "imagesloaded";


$(function () {

    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });

    let _hash, _scrollTop;
    $('a[href^="#anchor_"]').click(function (e) {
        e.preventDefault();
        _hash = $(this).attr('href');
        _hash = _hash.substr(_hash.indexOf('#'));
        _scrollTop = $(_hash).offset().top - $('.header').outerHeight(true) - $('.folder_label').outerHeight(true);
        console.log($('.header').outerHeight(true));
        gsap.to('html, body', { duration: 1, scrollTop: _scrollTop, ease: 'quart.out' });
    });

    //--------------------- imagesLoaded ---------------------//
    function removeLoading() {
        $(".loading").fadeOut(function () {
            $(this).remove();
        });
    }

    imagesLoaded("html, body", function () {
        removeLoading();
    });
});